import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box, Typography, Button } from "@mui/material";

const LoginPromptModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate("/login");
  };

  return (
    <Modal open onClose={onClose}>
      <Box
        sx={{
          p: 4,
          backgroundColor: "#1b1324",
          borderRadius: 2,
          color: "#fff",
          width: "90%",
          maxWidth: 400,
          mx: "auto",
          mt: "20%",
          textAlign: "center",
          boxShadow: 6,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Login to Lsnto
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          You must be logged in to play full tracks.
        </Typography>
        <Button
          onClick={handleLogin}
          variant="contained"
          sx={{
            bgcolor: "#FF0054",
            color: "#1b1324",
            fontWeight: "bold",
            "&:hover": { bgcolor: "#D70046" },
          }}
        >
          Go to Login
        </Button>
      </Box>
    </Modal>
  );
};

export default LoginPromptModal; 